import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Loader } from '@ui/loader';

import styles from './index.module.sass';

export function Authorizing(props: IAuthorizingProps) {
  const { className, loading, ...rest } = props;
  const rootClass = cn(className, styles.root);

  if (!loading) return null;
  return (
    <div className={rootClass} {...rest}>
      <Loader className={styles.loader} />
    </div>
  );
}

export interface IAuthorizingProps extends HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
}
